import { FontVariantSchema } from '../../definitions/schemas';

export const BOLD_FONT_VARIANT = '700';
export const REGULAR_FONT_VARIANT = 'regular';

export type WebfontVariant =
  | typeof BOLD_FONT_VARIANT
  | typeof REGULAR_FONT_VARIANT
  | '100'
  | '200'
  | '300'
  | '400'
  | '500'
  | '600'
  | '800'
  | '900';

export const WebfontVariantMap: Record<WebfontVariant, string> = {
  '100': 'Thin',
  '200': 'ExtraLight',
  '300': 'Light',
  '400': 'Regular',
  [REGULAR_FONT_VARIANT]: 'Regular',
  '500': 'Medium',
  '600': 'SemiBold',
  [BOLD_FONT_VARIANT]: 'Bold',
  '800': 'ExtraBold',
  '900': 'Black',
};

export interface WebfontFamily<VariantType = WebfontVariant> {
  family: string;
  standard?: boolean;
  variants: VariantType[];
}

export type WebfontFamilySchema = WebfontFamily<FontVariantSchema>;
export type WebfontList = WebfontFamilySchema[];

/**
 * GoogleFonts API
 * @see https://developers.google.com/fonts/docs/developer_api
 */
export type GoogleWebfontListFamily = WebfontFamily<string>;

export interface GoogleWebfontList {
  items: GoogleWebfontListFamily[];
}
